// import { Visibility, VisibilityOff } from '@mui/icons-material';
// import { IconButton, InputAdornment, TextField } from '@mui/material';
// import { useState } from 'react';

// const PasswordField = ({
//   passwordRef,
//   id = 'password',
//   label = 'Password',
//   autoFocus = true,
// }) => {
//   const [showPassword, setShowPassword] = useState(false);

//   const handleClick = () => {
//     setShowPassword(!showPassword);
//   };
//   const handleMouseDown = (e) => {
//     e.preventDefault();
//   };
//   return (
//     <TextField
//       autoFocus={autoFocus}
//       margin="normal"
//       variant="standard"
//       id={id}
//       label={label}
//       type={showPassword ? 'text' : 'password'}
//       fullWidth
//       required
//       inputRef={passwordRef}
//       inputProps={{ minLength: 6 }}
//       InputLabelProps={{
//         style: { color: '#777' },
//       }}
//       InputProps={{
//         endAdornment: (
//           <InputAdornment position="end">
//             <IconButton
//               aria-label="Toggle Password visibility"
//               onClick={handleClick}
//               onMouseDown={handleMouseDown}
//             >
//               {showPassword ? <VisibilityOff /> : <Visibility />}
//             </IconButton>
//           </InputAdornment>
//         ),
//       }}
//     />
//   );
// };

// export default PasswordField;
import { Visibility, VisibilityOff, Lock } from '@mui/icons-material';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { useState } from 'react';

const PasswordField = ({
  passwordRef,
  id = 'password',
  label = 'Password',
  autoFocus = true,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClick = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDown = (e) => {
    e.preventDefault();
  };

  return (
    <div >
      <TextField
        autoFocus={autoFocus}
        margin="normal"
        variant="outlined"
        id={id}
        type={showPassword ? 'text' : 'password'}
        fullWidth
        required
        inputRef={passwordRef}
        label="Password"
        inputProps={{ minLength: 6 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start"
            sx={{
              '& .MuiSvgIcon-root': {
                fontSize: '20px',
                color: '#777', // Default color
                transition: 'color 0.3s ease', // Smooth transition
              },
              '.Mui-focused & .MuiSvgIcon-root': {
                color: '#1976d2 !important', // Custom color on focus
              },
            }}
            >
              <Lock style={{ color: '#777' }} />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="Toggle Password visibility"
                onClick={handleClick}
                onMouseDown={handleMouseDown}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
          sx: {
            height: '50px',
            borderRadius: '25px', // Rounded corners
          },
        }}
        sx={{
          '& fieldset': {
            borderRadius: '25px', // Ensures the border itself is rounded
          },
          '& input': {
            backgroundColor: 'transparent !important', // Prevents blue autofill background
            WebkitBoxShadow: '0 0 0px 1000px white inset !important', // Overrides autofill styling
          },
          '& input:autofill': {
            backgroundColor: 'transparent !important',
            WebkitBoxShadow: '0 0 0px 1000px white inset !important',
          },
          '&:hover fieldset': {
            borderColor: '#1976d2', // Changes border color on hover
          },
          '&.Mui-focused fieldset': {
            borderColor: '#1976d2', // Changes border color when focused
          },
        }}
      />
    </div>
  );
};

export default PasswordField;